import { useState } from 'react';
import { Icon } from '@aqarmap/aqarmap-ui';
import { PackagesGridPlanType } from '~/pages/Packages/utils';

export default function ServicesList({ plan }: { plan: PackagesGridPlanType }) {
  const [checkedIndex, setCheckedIndex] = useState<number>(-1);
  const allowAccordion = (description?: string) => description;

  return (
    <div className="flex h-full flex-col">
      <ul className="flex h-full flex-col gap-x">
        {plan.services.map((service, index) => {
          const hasDescription = allowAccordion(service?.service?.description);

          return (
            <li
              key={`-${service.service.title}-${index}`}
              className={`rounded-[0px] ${
                hasDescription ? 'collapse' : ''
              } ${index === checkedIndex ? 'border-b border-gray_light_1' : ''}`}
              onClick={() =>
                hasDescription
                  ? setCheckedIndex((prev) => (prev === index ? -1 : index))
                  : undefined
              }
            >
              <input
                type="radio"
                name={`package-plan-services-${plan.key}`}
                checked={index === checkedIndex}
                hidden
                readOnly
              />
              <div
                className={`flex w-full justify-between gap-1x min-h-[24px] !p-0 ${
                  hasDescription ? 'collapse-title' : ''
                }`}
              >
                <div className="flex items-center gap-0.5x">
                  <Icon name="check" className="text-black" size="16px" />
                  <p className="text-caption-1 text-gray__dark_2">
                    {service.service.title}
                  </p>
                </div>
                {hasDescription && (
                  <div className="flex items-center ">
                    <Icon
                      name="chevron-down"
                      className={index === checkedIndex ? 'rotate-180' : ''}
                      size="16px"
                    />
                  </div>
                )}
              </div>

              {hasDescription && index === checkedIndex ? (
                <div className="collapse-content !px-0 !pb-1.5x !pt-x ">
                  <p className="text-caption-1 text-gray__dark_1">
                    {service.service.description}
                  </p>
                </div>
              ) : null}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
